<template lang="jade">

  div.input-text-component(:class="inline ? 'inline-input' : ''")
    label.control-label(for="my-input", v-if="showLabel")
      span(v-if="asterisk").glyphicon.glyphicon-asterisk.text-danger
      | {{ label }}

    input(type="text", v-if="useState || callback", v-model="localValue", :class="computedClasses",
      :placeholder="placeholder", :disabled="disabled",
      ref="input", v-on:input="value")

    input(type="text", v-else="", :class="computedClasses", :placeholder="placeholder", :disabled="disabled",
      ref="input", v-bind:value="value", v-on:input="$emit('input', $event.target.value)")


</template>

<script>
  export default {
    name: 'input-text',
    props: {
      useState: { type: String, default: null },
      callback: { type: Object, default: null },
      label: { type: String, default: '' },
      asterisk: { type: Boolean, default: false },
      className: { type: String, default: '' },
      inline: { type: Boolean, default: false },
      placeholder: { default: '' },
      disabled: { default: false },
      value: {}
    },
    computed: {
      showLabel () {
        return this.label !== ''
      },
      computedClasses () {
        return this.inline ? ['form-control', 'inline-input'] : ['form-control']
      },
      localValue: {
        get () {
          if (this.useState === null) {
            return this.callback.get()
          } else {
            return this.$store.getters[this.useState]
          }
        },
        set (value) {
          if (this.useState === null) {
            return this.callback.set(value)
          } else {
            this.$store.dispatch(this.useState, value)
          }
        }
      }
    }
  }
</script>

<style scoped>
  .inline-input {
    display: inline;
    padding: 0 3px;
    margin: 0 3px;
    width: 40px;
    height: 25px;
    border-radius: 1px;
  }
</style>



// WEBPACK FOOTER //
// InputText.vue?ea0bae28